
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    value: { type: Number, default: null },
    items: { type: Array as VuePropType<string[]>, required: true },
  },

  computed: {
    openedImg: {
      get (): number | null {
        return this.value
      },

      set (openedImg: number | null) {
        this.$emit("input", openedImg)
      },
    },
  },
})
